import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-basic-email',
  templateUrl: './basic-email.component.html',
  styleUrls: ['./basic-email.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class BasicEmailComponent {
  @Input() content: string | SafeHtml;
}
